import { createSlice } from "@reduxjs/toolkit";
import { AddSale, UpdateSale } from "services/sale/sale.service";
import { toast } from 'react-toastify';


export const saleAddSlice = createSlice({
  name: "saleAdd",
  initialState: {
    saleAdd: {},
    saleAddLoading: false,
    saleAddError: null,
  },
  reducers: {
    nullifySaleAdd: (state) => { // nulling the last scanning data from state
      state.saleAdd = {}; // Assign null to the state field
    },
  },
  extraReducers: 
  (builder) => {
    builder.addCase(AddSale.pending, (state) => {
      // toast.loading('We are adding the sale 🤯')
      state.saleAddLoading = true
    });

    builder.addCase(AddSale.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New sale added successfully 👌');

      state.saleAdd = action.payload
      state.saleAddLoading = false
      state.saleAddError = null
    });

    builder.addCase(AddSale.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the sale 😣")

      state.saleAddLoading = false
      state.saleAddError = action.error?.message
      toast.error(action.error?.message)
    });
  },
});

export const { nullifySaleAdd } = saleAddSlice.actions



export const saleUpdateSlice = createSlice({
  name: "saleUpdate",
  initialState: {
    saleUpdate: {},
    saleUpdateLoading: false,
    saleUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateSale.pending, (state) => {
      // toast.loading('We are updating the chalan 🤯')
      state.saleUpdateLoading = true
    });

    builder.addCase(UpdateSale.fulfilled, (state, action) => {
      // toast.dismiss();
      // toast.success('Chalan update successfully 👌');

      state.saleUpdate = action.payload
      state.saleUpdateLoading = false
      state.saleUpdateError = null
    });

    builder.addCase(UpdateSale.rejected, (state, action) => {
      // toast.dismiss();
      // toast.error("Opps! We can't update the chalan 😣")

      state.saleUpdateLoading = false
      state.saleUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});